/**
 * CloseAndCreateFormTypeSelect
 *
 * Target form-type picker inside `FormCloseAndCreateDrawer`'s body. Resolves the
 * permitted ids to their short labels from `formStore.state.formTypes`.
 *
 * Its own component so the drawer's `destroyOnHidden` unmounts this subscription
 * while closed — the drawer shell then reads nothing from the store, and the
 * form-type collection stays out of the action provider's render path.
 */

import { Select } from 'antd';
import { useSnapshot } from 'valtio';
import { formStore } from '@/store';

type CloseAndCreateFormTypeSelectProps = {
  allowedFormTypeIds: string[];
  selectedFormType: string | null;
  onChangeFormType: (value: string) => void;
};

export default function CloseAndCreateFormTypeSelect({
  allowedFormTypeIds,
  selectedFormType,
  onChangeFormType,
}: CloseAndCreateFormTypeSelectProps) {
  const snap = useSnapshot(formStore.state);
  const options = allowedFormTypeIds.map((formType) => ({
    value: formType,
    label: snap.formTypes.docs.get(formType)?.data?.description?.shortLabel || formType,
  }));

  return (
    <Select
      aria-label="close-and-create-create-form-type"
      options={options}
      value={selectedFormType ?? undefined}
      onChange={(value) => onChangeFormType(value as string)}
      placeholder="Select form type"
    />
  );
}
